<template>
  <div class="privateDetail">
    <div class="title">
      专线招标运单 <span>运单详情</span>
    </div>
    <div class="orderview_title">
      招标信息
      <!-- <span>运单号：{{privateNum}}</span> -->
    </div>
    <el-table style="width: 100%"
              :data="orderView"
              class="order_table">
      <el-table-column header-align="left"
                       align="left"
                       label="货源信息"
                       min-width="367px">
        <template slot-scope="scope">
          <div class="sourceInfo">
            <div class="orderList">
              <div>货源编号：</div>
              {{scope.row.goodsNo}}
            </div>
            <div class="orderList">
              <span>公司名称：</span>
              {{scope.row.companyName}}
            </div>
            <div class="orderList">
              <span>联系人姓名：</span>
              {{scope.row.companyLinkman}}
            </div>
            <div class="orderList">
              <span>联系电话：</span>
              {{scope.row.companyPhone}}
            </div>
            <div class="orderList">
              <span>货源有效期：</span>
              {{scope.row.startTime}}至{{scope.row.endTime}}
            </div>
          </div>
          <div class="logistics">
            <div class="orderList">
              <span>出发地：</span>
              {{scope.row.departureName}}{{scope.row.departureAddress}}
            </div>
            <div class="orderList">
              <span>目的地：</span>
              {{scope.row.destinationName}}{{scope.row.destinationAddress}}
            </div>
            <div class="orderList">
              <span>炼厂名称：</span>
              {{scope.row.factoryName}}
            </div>
            <div class="orderList">
              <span>原料：</span>
              {{scope.row.material}}
            </div>
            <div class="orderList">
              <span>重量：</span>
              {{scope.row.totalWeight}}
            </div>
            <div class="orderList">
              <span>罐体：</span>
              <p v-if="scope.row.tankBody === '0'">铝罐</p>
              <p v-else-if="scope.row.tankBody === '1'">铁罐</p>
              <p v-else-if="scope.row.tankBody === '2'">白钢罐</p>
              <p v-else-if="scope.row.tankBody === '3'">铝合金罐</p>
              <p v-else-if="scope.row.tankBody === '4'">其他</p>
            </div>

          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="left"
                       label="招标详情"
                       align="left"
                       class-name="order_car"
                       min-width="207px">
        <template slot-scope="scope">
          <div class="carInfo">
            <div>
              <span>已匹配重量：</span>
              {{scope.row.matchWeight}}
            </div>
            <div>
              <span>已匹配公司：</span>
              {{scope.row.matchVehicle}}
            </div>
            <div>
              <span>已谈成重量：</span>
              {{scope.row.talkWeight}}
            </div>
            <div>
              <span>已谈成公司：</span>
              {{scope.row.talkVehicle}}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态"
                       header-align="left"
                       align="left"
                       min-width="167px">
        <template slot-scope="scope">
          <div class="statusInfo">
            <div v-if="scope.row.transportStatus === 0">待匹配</div>
            <div v-else-if="scope.row.transportStatus === 1">待运输</div>
            <div v-else-if="scope.row.transportStatus === 2">运输中</div>
            <div v-else-if="scope.row.transportStatus === 3">运输完成</div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="carview_title">
      报价运单列表
    </div>
    <el-form :inline="true"
             :model="formInline"
             class="carview_form">
      <el-form-item label="运单编号"
                    size="small">
        <el-input v-model="formInline.truckBidNo"
                  placeholder="请输入运单编号"></el-input>
      </el-form-item>
      <el-form-item label="物流公司"
                    size="small">
        <el-input v-model="formInline.companyName"
                  placeholder="请输入物流公司名称"></el-input>
      </el-form-item>
      <el-button type="primary"
                 @click="onSubmit"
                 class="searchBtn">查询</el-button>
    </el-form>
    <el-table style="width: 100%"
              max-height="584"
              :data="data.order"
              :row-key="row_key"
              :expand-row-keys="expandRowKeys"
              ref="multipleTable"
              class="carview_table">
      <el-table-column prop="truckBidNo"
                       header-align="center"
                       align="center"
                       label="运单编号">
      </el-table-column>
      <el-table-column label="物流公司信息">
        <template slot-scope="scope">
          <div>
            <span>公司名称：</span>
            {{scope.row.companyName}}
          </div>
          <div>
            <span>联系人：</span>
            {{scope.row.logisticslinkMan}}
          </div>
          <div>
            <span>联系电话：</span>
            {{scope.row.companyPhone}}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="运费报价(元)"
                       align="center">
        <template slot-scope="scope">
          <div>
            {{scope.row.freightQuotation}}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="总核载量(吨)"
                       align="center">
        <template slot-scope="scope">
          <div>
            {{scope.row.totalLoad}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="招标详情"
                       align="left">
        <template slot-scope="scope">
          <div>
            <div>车辆总数:</div>
            {{scope.row.truckNo}}
          </div>
          <div>
            <div>已匹配车辆：</div>
            {{scope.row.truckNo}}
          </div>
          <div>
            <div>已谈成重量:</div>
            {{scope.row.talkWeight}}
          </div>
          <div>
            <div>已匹配重量：</div>
            {{scope.row.matchWeight}}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="状态"
                       align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status === 0">投标失败</div>
          <div v-if="scope.row.status === 10">待谈成</div>
          <div v-if="scope.row.status === 20">待匹配</div>
          <div v-if="scope.row.status === 21">待运输</div>
          <div v-if="scope.row.status === 22">运输中</div>
          <div v-if="scope.row.status === 23">运输完成</div>
          <div v-if="scope.row.status === 24">运输完成</div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="总装卸量"
                       align="center"
                       header-align="center">
        <template slot-scope="scope">
          <div>
            <span>总装车量(吨)：</span>
            {{scope.row.totalLoadingNum}}
          </div>
        </template>

      </el-table-column> -->
      <el-table-column class-name="operation"
                       label="操作"
                       align="center">
        <template slot-scope="scope">
          <el-button type="primary"
                     plain
                     class="btna"
                     v-show="!scope.row.onoff"
                     @click="toggle(scope.row)">查看车辆</el-button>
          <el-button type="primary"
                     plain
                     class="btna"
                     v-show="scope.row.onoff"
                     @click="toggle(scope.row)">收起</el-button>
        </template>
      </el-table-column>
      <el-table-column label=""
                       header-align="center"
                       align="center"
                       width="1"
                       type="expand">
        <template slot-scope="scope">
          <el-table style="width: 100%"
                    class="carview_table_detail"
                    :data="scope.row.carlist.truckOrderList"
                    show-summary
                    :summary-method="getSummaries"
                    max-height="526">
            <el-table-column header-align="center"
                             align="center"
                             label="车辆运单号">
              <template slot-scope="scope">
                <div>{{scope.row.truckOrderNo}}</div>
              </template>
            </el-table-column>
            <el-table-column label="车辆信息">
              <template slot-scope="scope">
                <div>
                  <span>车头号：</span>
                  {{scope.row.truckHeadNo}}
                </div>
                <div>
                  <span>车挂号：</span>
                  {{scope.row.truckEndNo}}
                </div>
                <div>
                  <span>核载量：</span>
                  {{scope.row.loadCapacity}}吨
                </div>
                <div class="carviewlist">
                  <span>罐体：</span>
                  <div v-if="scope.row.tankType === '01'">铝罐</div>
                  <div v-else-if="scope.row.tankType === '02'">铁罐</div>
                  <div v-else-if="scope.row.tankType === '03'">白钢罐</div>
                  <div v-else-if="scope.row.tankType === '04'">铝合金罐</div>
                </div>
                <div class="carviewlist">
                  <span>状态：</span>
                  <div v-if="scope.row.status === 1">待运输</div>
                  <div v-else-if="scope.row.status === 2">运输中</div>
                  <div v-else-if="scope.row.status === 3">运输完成</div>
                </div>
                <div class="carviewlist">
                  <span>备案介质：</span>
                  {{scope.row.recordMedium}}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="司机信息">
              <template slot-scope="scope">
                <div>
                  <span>姓名：</span>
                  {{scope.row.driverName}}
                </div>
                <div>
                  <span>手机号：</span>
                  {{scope.row.driverPhone}}
                </div>
                <div>
                  <div>身份证号：</div>
                  {{scope.row.driverIdcardNo}}
                </div>
              </template>
            </el-table-column>
            <el-table-column header-align="center"
                             label="装车量(吨)"
                             align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 2 |scope.row.status === 3">
                  {{scope.row.loadingNum}}
                  <p @click="handleGetimg(0,scope.row.id)"
                     class="loadimgBtn">
                    查看图片
                  </p>
                </div>
              </template>
            </el-table-column>
            <el-table-column header-align="center"
                             label="卸车量(吨)"
                             align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.status === 3">
                  {{scope.row.unloadNum}}
                  <p @click="handleGetimg(1, scope.row.id)"
                     class="loadimgBtn">
                    查看图片
                  </p>
                </div>

              </template>
            </el-table-column>
            <el-table-column label="操作"
                             header-align="center"
                             align="center"
                             width="165">
              <template slot-scope="scope">
                <div class="statusInfo">
                  <div @click="handleTrackClick(scope.row.id)">
                    查看轨迹
                  </div>
                </div>
              </template>
            </el-table-column>

          </el-table>

        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="titlename"
               :visible.sync="loadCar"
               class="loadCarImg">
      <el-carousel trigger="click"
                   arrow="always"
                   indicator-position='none'
                   :autoplay="false">
        <el-carousel-item v-for="(item,index) in imgList"
                          :key="index">
          <div class="imgMain">
            <img :src=item.imgUrl
                 alt="">
          </div>
          <div class="imgNums">{{index+1}}/{{imgList.length}}</div>
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <el-dialog title="运输轨迹"
               :visible.sync="track"
               class="loadCarImg">
      <div class="container">
        <el-amap vid="amapDemo"
                 :center="center"
                 :amap-manager="amapManager"
                 :zoom="zoom"
                 class="amap-demo">
        </el-amap>
      </div>
    </el-dialog>
    <el-tabs v-model="activeName"
             class="evaluate_title"
             @tab-click="handleClick(activeName)">
      <el-tab-pane label="来自货主公司的评价"
                   name="0"></el-tab-pane>
      <el-tab-pane label="来自物流公司的评价"
                   name="1"></el-tab-pane>
    </el-tabs>
    <el-table style="width: 100%"
              max-height="584"
              :data="comments.result"
              class="evaluate_table">
      <el-table-column header-align="center"
                       label="评论信息"
                       align="center"
                       min-width='160'>
        <template slot-scope="scope">
          <el-rate v-model="scope.row.commentStars"></el-rate>
          <div>
            {{scope.row.remarks}}
          </div>
          <div class="evaluate_tag">
            <div v-for="item in scope.row.tags"
                 :key="item.index">{{item}}</div>

          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="activeName === '0'"
                       header-align="center"
                       label="被评价的物流公司"
                       align="center">
        <template slot-scope="scope">
          <div class="evaluate_icon">
            <img src="http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg"
                 alt="">
          </div>
          <div>
            {{scope.row.logisticCompanyName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column v-else-if="activeName === '1'"
                       header-align="center"
                       label="发表评价的物流公司"
                       align="center">
        <template slot-scope="scope">
          <div class="evaluate_icon">
            <img src="http://img.zcool.cn/community/01528a58e4c8e6a801219c77b0154e.png@900w_1l_2o_100sh.jpg"
                 alt="">
          </div>
          <div>
            {{scope.row.logisticCompanyName}}
          </div>
        </template>
      </el-table-column>
      <el-table-column header-align="center"
                       label="评论日期"
                       align="center">
        <template slot-scope="scope">
          <div>
            {{scope.row.createDate}}
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages"
         v-show="comments.total!==0">
      <span class="demonstartion"> 共{{comments.total}}条记录</span>
      <el-pagination @current-change="handleCurrentChange"
                     :page-size="comments.pageSize"
                     layout="prev, pager, next"
                     :total="comments.total"
                     background>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getPrivateDetail, getPrivateCarDetail, getPrivateTrack, getPrivateImg, getPrivateEvaluate } from 'apis/index'
import VueAMap from 'vue-amap'
let amapManager = new VueAMap.AMapManager()
export default {
  name: 'privateDetail',
  data () {
    return {
      data: {},
      orderView: [],
      driversList: [],
      privateNum: '',
      id: '',
      formInline: {
        truckBidNo: '',
        companyName: ''
      },
      loadCar: false,
      track: false,
      imgList: [],
      titlename: '',
      trajectory: {},
      zoom: 6,
      center: [116.3802337646, 39.8631078118],
      amapManager,
      startlatitude: [],
      endlatitude: [],
      activeName: '0',
      comments: {},
      expandRowKeys: [],
      trackList: [],
      off: true
    }
  },
  methods: {
    row_key (row) {
      return row.id
    },
    getCompanyOrderList (id) { // 获取公司运单
      //   privateOrderView({
      //     companyOrderId: id
      //   }).then(res => {
      //     if (res.data.code === 0) {
      //       this.privateNum = res.data.data.result.goodsNum
      //       this.orderView.push(res.data.data.result)
      //     }
      //   })
    },
    getData () { // 初始化页面，获取运单详情
      getPrivateDetail({
        goodsId: this.id,
        truckBidNo: this.formInline.truckBidNo,
        companyName: this.formInline.companyName
      }).then(res => {
        if (res.data.code === 0) {
          this.data = res.data.data
          this.orderView = []
          this.orderView.push(this.data.goods)
          this.data.order.forEach(element => {
            getPrivateCarDetail({
              orderId: element.id
            }).then(res => {
              if (res.data.code === 0) {
                // console.log(res)
                res.data.data.truckOrderList.forEach(cElement => {
                  cElement.totalLoadingNum = res.data.data.totalLoadingNum
                  cElement.totalUnloadNum = res.data.data.totalUnloadNum
                })

                element.carlist = res.data.data
              }
            })
          })
          // console.log('aaa', this.data)
          this.startlatitude.push(this.data.goods.departureLng, this.data.goods.departureLat)
          this.endlatitude.push(this.data.goods.destinationLng, this.data.goods.destinationLat)
          // console.log('bbb', this.data.order[0])
        }
      })
    },
    getSummaries (param) {
      // console.log('params', param)
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        sums[5] = '总装车量(吨)：' + data[0].totalLoadingNum.toFixed(3) + '总卸车量(吨)：' + data[0].totalUnloadNum.toFixed(3)
      })

      return sums
    },
    getEvaluate (type = 0, pages = 1) { // 获取评价
      getPrivateEvaluate({
        goodsId: this.id,
        type: type,
        pageNum: pages
      }).then(res => {
        if (res.data.code === 0) {
          this.comments = res.data.data
          // console.log('com', this.comments)
          this.comments.result.forEach(element => {
            element.tags = element.commentContent.split(',')
          })
        }
      })
    },
    handleClick (type) { // 切换评价
      this.getEvaluate(type)
      // console.log(type)
    },
    handleCurrentChange (val) { // 切页切换
      let pageNum = val
      let type = this.activeName
      this.getEvaluate(type, pageNum)
    },
    onSubmit () { // 运单列表查询
      this.expandRowKeys = []
      this.getData()
      // conso
      // getPrivateDetail({
      //   goodsId: this.id,
      //   truckBidNo: this.formInline.truckBidNo,
      //   companyName: this.formInline.companyName
      // }).then(res => {
      //   if (res.data.code === 0) {
      //     this.data = res.data.data
      //     this.orderView = []
      //     this.orderView.push(this.data.goods)
      //   }
      // })
    },
    handleGetimg (item, id) { // 获取图片
      this.imgList = []
      getPrivateImg({
        truckOrderId: id
      }).then(res => {
        if (res.data.code === 0) {
          // console.log(res.data.data)
          // console.log(typeof res.data.data.loadingImg)
          if (item === 0) {
            this.titlename = '装车量'
            this.imgList = res.data.data.loadingImg
            if (res.data.data.loadingImg) {
              this.loadCar = true
            } else {
              this.$alert('暂无图片', {
                confirmButtonText: '确定'
              })
            }
          } else if (item === 1) {
            this.titlename = '卸车量'
            this.imgList = res.data.data.unloadImg
            if (res.data.data.unloadImg) {
              this.loadCar = true
            } else {
              // console.log('没有卸车辆')
              this.$alert('暂无图片', {
                confirmButtonText: '确定'
              })
            }
          }
        }
      })
    },

    handleTrackClick (id) { // 查看运单轨迹
      this.track = true
      getPrivateTrack({
        truckOrderId: id
      }).then(res => {
        console.log(res)
        if (res.data.code === 0) {
          // console.log(res)
          //   this.trajectory = [
          //     {
          //       'id': 'e895ae56-9e4e-4cd2-9944-cd1ab7ad5941',
          //       'truckOrderId': 'e895ae56-9e4e-4cd2-9944-cd1ab7ad5941',
          //       'lng': '123',
          //       'lat': '21',
          //       'createDate': '2019-01-17 02:18:35',
          //       'delFlag': '0'
          //     },
          //     {
          //       'id': 'c461a9cd-2974-4bd4-a720-513376d05f51',
          //       'truckOrderId': 'e895ae56-9e4e-4cd2-9944-cd1ab7ad5941',
          //       'lng': '123.456',
          //       'lat': '98.698',
          //       'speed': 119,
          //       'angle': 30,
          //       'createDate': '2019-01-15 02:41:52',
          //       'updateDate': '2019-01-15 02:41:52',
          //       'delFlag': '0'
          //     },
          //     {
          //       'id': 'b142daf7-7f40-4357-814d-464ce7fdd702',
          //       'truckOrderId': 'e895ae56-9e4e-4cd2-9944-cd1ab7ad5941',
          //       'lng': '123.123',
          //       'lat': '66.6',
          //       'createDate': '2019-01-17 02:34:42',
          //       'updateDate': '2019-01-17 02:34:42',
          //       'delFlag': '0'
          //     },
          //     {
          //       'id': 'f9f4140a-43d4-4f24-acfb-a1ff00c45ad9',
          //       'truckOrderId': 'e895ae56-9e4e-4cd2-9944-cd1ab7ad5941',
          //       'lng': '123.123',
          //       'lat': '66.6',
          //       'createDate': '2019-01-17 02:37:54',
          //       'updateDate': '2019-01-17 02:37:54',
          //       'delFlag': '0',
          //       'dateTime': '2018-10-23 02:23:04'
          //     }
          //   ]
          this.trajectory = res.data.data.truckLocationList
          console.log('aaa', this.trajectory)
          if (this.trajectory.length !== 0) {
            this.trackList = []
            this.trajectory.forEach(element => {
              // console.log('element', element)
              let list = []
              list.push(element.lng)
              list.push(element.lat)
              this.trackList.push(list)
            })
          } else {
            console.log('暂无数据')
          }

          let sMap = amapManager.getMap()
          sMap.clearMap()

          // 出发地坐标点
          let startPoint = this.startlatitude
          //   startPoint = this.trajectory
          let srtatIcon = new AMap.Icon({
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            imageSize: new AMap.Size(135, 40),
            imageOffset: new AMap.Pixel(-9, 0)
          })
          this.remarkPoint(startPoint, srtatIcon)

          // 目的地坐标点
          let endPoint = this.endlatitude
          let endIcon = new AMap.Icon({
            image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
            imageSize: new AMap.Size(135, 40),
            imageOffset: new AMap.Pixel(-95, -3)
          })
          this.remarkPoint(endPoint, endIcon)

          // 将当前车辆位置坐标点定位为地图中心点
          this.center = this.trackList[this.trackList.length - 1]
          let centerIcon = new AMap.Icon({
            image: ''
          })
          this.remarkPoint(this.center, centerIcon)

          // 创建一个 icon
          let remark = new AMap.Marker({
            position: this.center,
            icon: 'http://image.jsh178.com/FmQdHrf-kE2vPHc4AxAH1xHFl0qI',
            offset: new AMap.Pixel(-26, -13),
            autoRotation: true,
            angle: -90
          })
          // 绘制轨迹
          let polyline = new AMap.Polyline({
            map: sMap,
            path: this.trackList,
            showDir: false,
            strokeColor: '#1b88ee', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          let passedPolyline = new AMap.Polyline({
            map: sMap,
            // path: trackList,
            strokeColor: '#1b88ee', // 线颜色
            // strokeOpacity: 1,     //线透明度
            strokeWeight: 6 // 线宽
            // strokeStyle: "solid"  //线样式
          })
          remark.on('moving', function (e) {
            passedPolyline.setPath(e.passedPath)
          })
          sMap.setFitView()
          remark.moveAlong(this.trackList, 9999999999)
          remark.setMap(sMap)
        }
      })
    },
    remarkPoint (item, icon) {
      let o = amapManager.getMap()
      // 创建一个 icon
      let remark = new AMap.Marker({
        size: new AMap.Size(25, 34),
        position: item,
        icon: icon,
        zoom: 6,
        center: this.center
      })
      remark.setMap(o)
    },
    toggle (row) { // 投标详情展示下拉列表
      /*
        expandRowKeys里存放要展开的id
        如果要展开，就把id放进去，如果要关闭，就把id从里面删掉
        如果要全部关闭，就把expandRowKeys清空
      */
      row.onoff = !row.onoff
      if (this.expandRowKeys.length) {
        this.expandRowKeys.forEach(element => {
          if (element === row.id) {
            this.expandRowKeys = this.expandRowKeys.filter(res => {
              return res !== row.id
            })
          } else {
            this.expandRowKeys.push(row.id)
          }
        })
      } else {
        this.expandRowKeys.push(row.id)
      }
    }
  },
  mounted () {
    this.id = this.$route.query.item
    this.getData()
    this.getEvaluate()
    // this.getCompanyOrderList(this.id)
    // this.getDriverList(this.id)
  }

}

</script>
<style lang="stylus">
@import '~styles/mixins.styl'
@import '~styles/varibles.styl'
.privateDetail
  background #f7f9fb
  padding 0 20px
  font-size 12px
  overflow-y auto
  min-width 818px
  padding-bottom 20px
  .title
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../assets/images/01/nav_arrow.png') no-repeat top 21px left 80px #F7F9FB
    span
      color #212832
      margin-left 20px
  .orderview_title
    width calc(100% - 46px)
    line-height 46px
    border-bottom 1px solid #eee
    padding-left 46px
    background url('../../../assets/images/02/zhaobiao_icon.png') no-repeat center left 14px #fff
    span
      float right
      margin-right 20px
  .order_table
    border-bottom 1px solid #ccc
    border-top 1px solid #ccc
    th
      background #e7f0f8
      border-bottom 1px solid #ccc
      .cell
        size12()
        padding-left 40px
    td
      size12()
      .sourceInfo, .logistics
        width 40%
        float left
        margin-left 30px
        color #5E656F
        .orderList
          div
            color #858C96
          span
            color #858C96
          p
            display inline
      .carInfo
        margin-left 30px
        div
          color #5E656F
          span
            color #858C96
      .statusInfo
        margin-left 30px
        color #1B88EE
    td.order_car
      border-left 1px solid #ccc
      border-right 1px solid #ccc
  .el-table td, .el-table th
    vertical-align top
  .el-table__expanded-cell
    padding 0
  .carview_title
    width calc(100% - 46px)
    line-height 46px
    border-bottom 1px solid #eee
    padding-left 46px
    margin-top 20px
    background url('../../../assets/images/02/baojia_icon.png') no-repeat center left 14px #fff
  .carview_form
    background #fff
    padding-left 14px
    .searchBtn
      // padding 6px 24px
      searchBtn()
      margin-top 9px
      float right
      margin-right 20px
    .el-form-item
      margin-bottom 6px
      margin-top 6px
  .carview_table
    th
      background #e7f0f8
      .cell
        size12()
    td
      size12()
      .loadimgBtn
        color #1B88EE
        text-decoration underline
        cursor pointer
      .statusInfo
        div
          margin 0 auto
          width 78px
          height 28px
          line-height 28px
          background #1B88EE
          border-radius 3px
          color #fff
          cursor pointer
        .canceled
          background #CFD5DC
          cursor auto
          border-radius 3px
      .carviewlist
        div
          display inline
      .btna
        btna()
  .carview_table_detail
    background #E6F3FE
    th
      background #E6F3FE
      .cell
        size12()
    tr
      background #E6F3FE
    .el-table__footer-wrapper
      th
        background #e6f3fe
      td
        background #E6f3fe
        font-weight 600
        font-size 13px
        padding-right 10px
        // background #f66
  .count
    text-align right
    font-size 16px
    color #212832
    line-height 30px
    span
      color #5E656F
      font-size 12px
  .el-dialog
    width 90vw
    height 90%
    margin-top 2vw !important
    .el-dialog__header
      height 42px
      padding 0 20px 0
      text-align left
      background #1b88ee
      line-height 42px
      .el-dialog__title
        font-size 13px
        color #fff
    .el-dialog__headerbtn
      top 12px
      right 12px
      .el-dialog__close
        color #fff
        font-size 20px
    .el-dialog__body
      height calc(100% - 62px)
      padding 12px
      .el-carousel
        width 100%
        height 100%
        .el-carousel__container
          width 100%
          height 100% !important
          margin 0 auto
        .el-carousel__arrow--left
          left 0px
          width 21px
          height 38px
          background url('../../../assets/images/02/left_n_page.png') no-repeat
          &:hover
            background url('../../../assets/images/02/left_h_page.png') no-repeat
        .el-icon-arrow-right:before
          content '' !important
        .el-carousel__arrow--right
          right 0px
          width 21px
          height 38px
          background url('../../../assets/images/02/righe_n_page.png') no-repeat
          &:hover
            background url('../../../assets/images/02/right_h_page.png') no-repeat
        .el-icon-arrow-left:before
          content '' !important
        .imgMain
          width 100%
          height 100%
          position relative
          img
            height 100%
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
        .imgNums
          position absolute
          bottom 10px
          left 50%
          transform translatex(-50%)
    .container
      width 100%
      height 100%
      .amap-demo
        width 100%
        height 100%
  .evaluate_title
    width 100%
    height 46px
    line-height 46px
    font-size 12px
    color #858C96
    margin-top 20px
    background #fff
    .el-tabs__nav-wrap::after
      height 1px
      bottom 1px solid transparent
    .el-tabs__item
      width 150px
      height 46px
      padding 0
      text-align center
      line-height 46px
      size12()
      color #5e656f
    .el-tabs__item.is-active
      border-bottom 2px solid #409EFF
      color #fff
      background #409EFF
    .el-tabs__active-bar
      background transparent !important
  .evaluate_table
    th
      background #e7f0f8
      .cell
        size12()
    td
      size12()
      .evaluate_tag
        overflow hidden
        text-align center
        div
          display inline-block
          width 118px
          height 26px
          border 1px solid #CFD5DC
          margin 6px
      .evaluate_icon
        display inline-block
        width 42px
        height 42px
        border-radius 20px
        overflow hidden
        img
          width 100%
  .pages
    padding-top 15px
    margin-bottom 15px
    background #fff
    .demonstartion
      float right
      margin-right 15px
      line-height 45px
      color #5e656f
</style>
